export default "__VITE_ASSET__BJRMgljz__"